import { ConsumablesMasterThemeModeConfig } from './types';

const dark: ConsumablesMasterThemeModeConfig = {
  consumablesMaster: {},
};

export default dark;
